export function filterQuery(text, regEx) {
	// Regex will allow only alphanumeric and  special chars: -&)(.% in between
	if (!regEx.test(text)) {
		return '';
	}

	return text.trim().toLowerCase();
}
export const regEx = {
	/* eslint-disable */
	GOOGLE_SEARCH: /.*/,
	INSTRUMENT_SEARCH: /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 \-\&\.\(\)\%]*)?$/
};
